import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/auth/group');
  }
}

export default new API();
